import { forwardRef } from 'react';
import { getGridChildStyles } from './GridChildStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const GridChild = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    colStart,
    rowStart,
    colSpan,
    rowSpan,
    colStartMobileLarge,
    rowStartMobileLarge,
    colSpanMobileLarge,
    rowSpanMobileLarge,
    colStartTablet,
    rowStartTablet,
    colSpanTablet,
    rowSpanTablet,
    colStartTabletLarge,
    rowStartTabletLarge,
    colSpanTabletLarge,
    rowSpanTabletLarge,
    colStartDesktop,
    rowStartDesktop,
    colSpanDesktop,
    rowSpanDesktop,
    ...rest
  } = _ref;
  const gridChildType = {
    colStart,
    rowStart,
    colSpan,
    rowSpan,
    colStartMobileLarge,
    rowStartMobileLarge,
    colSpanMobileLarge,
    rowSpanMobileLarge,
    colStartTablet,
    rowStartTablet,
    colSpanTablet,
    rowSpanTablet,
    colStartTabletLarge,
    rowStartTabletLarge,
    colSpanTabletLarge,
    rowSpanTabletLarge,
    colStartDesktop,
    rowStartDesktop,
    colSpanDesktop,
    rowSpanDesktop
  };
  return jsx("div", {
    css: getGridChildStyles(gridChildType),
    ref: ref,
    ...rest,
    children: children
  });
});
GridChild.displayName = 'GridChild';

export { GridChild };
//# sourceMappingURL=GridChild.js.map
